import { isEmail, isLogin, isPassword, isPhone, isRouteId, isText } from './FormValidation';

export function isOrganisationCreateValid(payload: Record<string, unknown>, parents: readonly number[], types: readonly number[]): boolean {
    const user = payload.user;
    if (!user || typeof user !== 'object') return false;
    const fields = user as Record<string, unknown>;
    return isRouteId(payload.parentId) && parents.includes(payload.parentId)
        && isRouteId(payload.type) && payload.type >= 2 && payload.type <= 4 && types.includes(payload.type)
        && isText(payload.name, 5, 255) && ['admin', 'user'].includes(String(fields.type))
        && typeof fields.type === 'string' && isLogin(fields.login) && isPassword(fields.password)
        && isText(fields.name, 5, 255) && isPhone(fields.phone) && isEmail(fields.email);
}

/** Update DTO makes metadata optional; activation remains required for every role. */
export function organisationUpdatePayload(form: Record<string, unknown>, original: Record<string, unknown>, allFields: boolean): Record<string, unknown> {
    const payload: Record<string, unknown> = { isActive: form.isActive };
    if (allFields) for (const field of ['parentId', 'type', 'name']) {
        if (form[field] !== original[field]) payload[field] = form[field];
    }
    return payload;
}
export function isOrganisationUpdateValid(payload: Record<string, unknown>, parents: readonly number[], types: readonly number[]): boolean {
    return typeof payload.isActive === 'boolean'
        && (!('name' in payload) || isText(payload.name, 5, 255))
        && (!('parentId' in payload) || isRouteId(payload.parentId) && parents.includes(payload.parentId))
        && (!('type' in payload) || isRouteId(payload.type) && payload.type >= 2 && payload.type <= 4 && types.includes(payload.type));
}
